import LeftGroupList from "@/components/LeftGroupList";
import ButtonDialog from "@/components/ButtonDialog";
import api from "@/api";
export default {
  name: "Unfolding3DView",
  components: {
    LeftGroupList,
    ButtonDialog
  },
  data() {
    return {
      groups: [],
      groupId: null,
      questions: [],
      typeMap: {}
    };
  },
  methods: {
    deleteGroup() {
      api.deleteUnfolding3dGroup(this.groupId).then(() => {
        this.init();
      });
    },
    deleteLogicalQuestion(qid) {
      api.deleteUnfolding3dQuestion(qid).then(() => {
        this.fetchList();
      });
    },
    onChoose(gid) {
      this.groupId = gid;
      this.fetchList();
    },
    fetchList() {
      api.getUnfolding3DQuestionByGroupId(this.groupId).then(ret => {
        this.questions = ret.list;
      });
    },
    init() {
      api.getUnfolding3DQuestionGroups().then(list => {
        this.groups = list;
        this.groupId = list[0].value;
        this.fetchList();
      });
      api.getLogicalQuestionTypeMap().then(ret => {
        this.typeMap = ret;
      });
    }
  },
  mounted() {
    this.init();
  }
};